import React from 'react';
import {createResource, type ResourceType} from 'api/generated';
import {Button, InputFile, Modal} from 'components';
import {useCreateFile} from 'hooks';

interface IModalFileUploadProps {
  visible: boolean;
  onClose: () => void;
  onUploaded: (resource: ResourceType) => void;
}

const ModalFileUpload = ({visible, onClose, onUploaded}: IModalFileUploadProps) => {
  const {handleUpload, inputRef, isPending, progress} = useCreateFile({
    createFile: createResource,
    callback: onUploaded,
  });
  return (
    <Modal visible={visible} onClose={onClose} backdropClose={!isPending}>
      <InputFile
        inputRef={inputRef}
        buttonText="+ Add image file"
        accept="image/*"
        supportedFormats={['jpg', 'png']}
        onUpload={handleUpload}
        loading={isPending}
        progress={progress}
      />
      <div className="w-full flex flex-col items-center mt-5">
        <Button text="Cancel" variant="secondary" size="extra-small" onClick={onClose} disabled={isPending} />
      </div>
    </Modal>
  );
};

export default React.memo(ModalFileUpload);
